import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'

import { Box, CssBaseline, useTheme } from '@mui/material';
import MonthlyPlant1Log from './MonthlyPlant1Log/MonthlyPlant1Log';
import MonthlyPlant1Curve from './MonthlyPlant1Curve/MonthlyPlant1Curve';

function MonthlyPlant1({SUB_PLANT}) {
    const [key, setKey] = useState('Energy Log');
    const { spacing } = useTheme()
    return (
        <>
            <CssBaseline />
            <Box sx={{ bgcolor: 'background.default', py: spacing(1) }}>
                <Tabs
                    style={{ justifyContent: "flex-start", }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    <Tab eventKey="Energy Log" title="Energy Log">
                    <MonthlyPlant1Log SUB_PLANT={SUB_PLANT}/>    
                    </Tab>

                    <Tab eventKey="Energy Curve" title="Energy Curve">
                    <MonthlyPlant1Curve SUB_PLANT={SUB_PLANT}/>
                    </Tab>
                    
                </Tabs>
            </Box>
        </>
    )
}

export default MonthlyPlant1
